import * as React from "react";
import { memo } from "react";

import type { IIconBaseProps } from "@components/icons/icon";

export const IconWrapper = memo(function IconWrapper({
  icon,
  color: colorProp,
  size: sizeProp,
  autoSize,
  ...restProps
}: IIconBaseProps & { icon: React.ReactNode }) {
  const color = colorProp || "currentColor";
  const size = sizeProp ? `${sizeProp / 16}rem` : "1rem";

  return (
    <span
      role={"img"}
      aria-hidden={"true"}
      style={{
        color,
        width: size,
        height: size,
        display: "flex",
        fontSize: "inherit",
        justifyContent: "center",
        alignItems: "center",
      }}
      {...restProps}
    >
      {icon}
    </span>
  );
});
